module.exports = __webpack_public_path__ + "assets/img/101103.5f67afdc.svg";